
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
    Ref,
} from "vue";

const columnList: Array<any> =  [
    {
        prop: "code",
        label: "车牌号码",
        width: 73,
    },
    {
        prop: "vin",
        label: "车架号",
        width: 113,
    },
    {
        prop: "model_name",
        label: "品牌车型",
        width: 73,
    },
    {
        prop: "repair_unit_name",
        label: "所属单位",
        width: 113,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 73,
    },
    {
        prop: "phone",
        label: "手机",
        width: 113,
    },
    // {
    //     prop: "text",
    //     label: "到期类别",
    //     width: 153,
    // }
];
import { Request } from "@/api/request";
import {ElLoading, ElMessageBox} from "element-plus";
import {carDueExport, carManageExport, permissionList} from "@/api/http";
export default defineComponent({
    name: "Expire",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["到期提醒"]);

        let pageSize = ref(10),
            currentPage = ref(1),
            loading = ref(false),
            total = ref(0),
            roleList = ref({} as any),
            headClass = inject("headClass"),
            project = ref([]),
            tableData = ref([] as Array<any>),
            screenParameter: Ref<any> = ref({
                date: null,
                start_time: null,
                end_time: null,
                search: null,
                status: null,
            });

        let getTableData = () => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'customer_expire',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                let data: any = {
                    ...screenParameter.value,
                    page: currentPage.value,
                    pagesize: pageSize.value,
                };
                delete data.date;
                Object.keys(data).forEach((key) => {
                    if (data[key] == null) {
                        delete data[key];
                    }
                });
                Request.axiosInstance({
                    url: "adminapi/CustomerService/carDueV2",
                    data,
                }).then((res: any) => {
                    loading.value = false;
                    tableData.value = res?.content?.list || [];
                    total.value = res?.content?.total || 0;
                });
            },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            handle = (id: number) => {
                ElMessageBox.prompt('请输入跟进备注信息', '已处理', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPlaceholder: '请输入备注信息',
                    inputType: 'textarea'
                })
                    .then(({ value }) => {
                        Request.axiosInstance({
                            url: "adminapi/CustomerService/carDueDealV2",
                            data: {
                                id: id,
                                remark: value
                            },
                        }).then((res: any) => {
                            getTableData();
                        });
                    })
                    .catch(() => {});
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
    
                carDueExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            screenChange = (e: string, key: string | null): void => {
                if (key && e) {
                    if (key == 'start_date'){
                        screenParameter.value.start_time = e[0]
                            ? new Date(e[0]).getTime()/1000
                            : null;
                        screenParameter.value.end_time = e[1]
                            ? new Date(e[1]).getTime()/1000
                            : null;
                    }
                    
                }else{
                    if (key == 'start_date'){
                        screenParameter.value.start_time = null;
                        screenParameter.value.end_time = null;
                    }
                }
                currentPage.value = 1;
                getTableData();
            };
        onMounted(() => {
            getTableData();
            Request.axiosInstance({
                url: "adminapi/Project/list",
                data: {
                    status: 1,
                },
            }).then((res: any) => {
                project.value = res?.content?.list || [];
            });
        });

        return {
            pageSize,
            currentPage,
            columnList,
            loading,
            tableData,
            project,
            handleSizeChange,
            handleCurrentChange,
            total,
            handle,
            headClass,
            screenChange,
            screenParameter,
            exportChange,
            roleList
        };
    },
});
